import { render, staticRenderFns } from "./create-bank.vue?vue&type=template&id=06f46436&"
import script from "./create-bank.vue?vue&type=script&lang=js&"
export * from "./create-bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports